this.values.memory<template>
  <motlet :options="motletOptions">
    <template #content>
      <v-row class="h-100">
        <v-col col="6">
          <v-card class="card-wrap">
            <v-card-title>CPU</v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <cpu
                :values="cpu"
                :system="system"
                :items="nodes"
                :formatter="formatter.cpu"
                :max="100"
                :contextmenu="onContextmenuChart"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col col="6">
          <v-card class="card-wrap">
            <v-card-title>Memory</v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <memory
                :values="memory"
                :system="system"
                :items="nodes"
                :formatter="formatter.memory"
                :max="100"
                :contextmenu="onContextmenuChart"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import Cpu from '../chart/BarVertical.vue';
import Memory from '../chart/BarVertical.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    Cpu,
    Memory,
  },
  data() {
    return {
      motletOptions: {
        id: 'overview/system/java/OperationSystem',
        title: 'Operation System',
      },
      messages: [
        {
          name: 'rawJavaOsCpu',
          fields: ['stime', 'usr', 'sys'],
        },
        {
          name: 'rawJavaOsMem',
          fields: ['stime', 'memFree', 'memSize'],
        },
        {
          name: 'rawJavaOsInfo',
          fields: ['stime', 'cpuUtil', 'memUtil'],
        },
      ],
      messageSequence: 0,
      values: {
        cpu: {},
        memory: {},
      },
      osInfo: {
        cpu: {},
        memory: {},
      },
      cpu: {},
      memory: {},
      formatter: {
        cpu: param => `${param.value} %`,
        memory: param => `${param.value} %`,
      },
      contextmenuUrl: '/views/detailview/java/os',
    };
  },
  watch: {
    nodes: {
      handler: 'changeNodesHandler',
    },
  },
  methods: {
    wsBufferedDataHandler(key, responses, every) {
      responses.forEach(response => {
        const last = response.length ? response[response.length - 1] : { data: [], ctime: '', empty: true };
        every(key, last.data, last.ctime, last.empty);
      });
    },
    wsDataHandler(key, response) {
      // 그룹 별 첫번째 message 수신의 경우 값 초기화
      if (key.name == this.messages[0].name) {
        ++this.messageSequence;
        this.values.cpu[key.nodeId] = 0;
        this.values.memory[key.nodeId] = 0;
        this.osInfo.cpu[key.nodeId] = 0;
        this.osInfo.memory[key.nodeId] = 0;
      }

      // 2. 그룹별 데이터 누적처리
      response.forEach(res => {
        if (key.name == 'rawJavaOsCpu') {
          this.values.cpu[key.nodeId] = parseInt(res.usr) + parseInt(res.sys);
        } else if (key.name == 'rawJavaOsMem') {
          this.values.memory[key.nodeId] = Math.round((1 - parseInt(res.memFree) / parseInt(res.memSize)) * 100);
        } else if (key.name == 'rawJavaOsInfo') {
          this.osInfo.cpu[key.nodeId] = res.cpuUtil;
          this.osInfo.memory[key.nodeId] = res.memUtil;
        }
      });

      // 3. 그룹 별 마지막 message 수신의 경우 처리
      if (key.name == this.messages[this.messages.length - 1].name) {
        // 시스템에 속한 노드들의 값이 모두 취합 된 후
        if (this.messageSequence == this.nodes.length) {
          const cpu = {};
          const memory = {};
          this.nodes.forEach(node => {
            cpu[node.id] = this.values.cpu[node.id] || this.osInfo.cpu[node.id] || 0;
            memory[node.id] = this.values.memory[node.id] || this.osInfo.memory[node.id] || 0;
          });
          this.cpu = cpu;
          this.memory = memory;
          this.messageSequence = 0;
        }
      }
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.nodes.reduce(
          (acc, node) =>
            acc.concat(
              this.messages.map(message => ({
                key: { name: message.name, sstmId: node.systemId, instId: node.instanceId, nodeId: node.id },
                fields: message.fields,
                empty: false,
                handler: {
                  buffer: this.wsBufferedDataHandler,
                  every: this.wsDataHandler,
                },
              })),
            ),
          [],
        ),
      });
    },
    initialize() {
      this.messageSequence = 0;
      // value init
      Object.keys(this.values).forEach(key => (this.values[key] = {}));
      Object.keys(this.osInfo).forEach(key => (this.osInfo[key] = {}));
      // websoket message init
      this.wsRequestMessages = {};
    },
    changeNodesHandler() {
      this.initialize();
      this.sendMessage();
    },
  },
};
</script>

<style scoped>
.chart-area {
  height: calc(100% - 37px);
}
</style>
